<template>
  <div>
    <h4>Welcome to Connect Copilot</h4>
  </div>
  <div class="row">
    <div class="col">
      <p></p>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <blog-host v-if="!isLocator" />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { dashboardStore } from '@/stores/dashboard'
import { opportunityStore } from '@/stores/opportunity'
import { locationStore } from '@/stores/location'
import BlogHost from '@/components/blog/blog-listing.vue'
export default {
  name: 'HomePage',
  components: {
    BlogHost
  },
  async mounted() {
    this.init()
  },
  computed: {
    ...mapState(authStore, ['profile']),
    isSuperAdmin() {
      let _is = false
      if ([1].includes(this.profile.roles[0])) {
        _is = true
      }
      return _is
    },
    isProvider() {
      let _is = false
      if ([2, 3].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    },
    isLocator() {
      let _is = false
      // 6 = Locator Group
      // 7 = Locator
      if ([6, 7].includes(this.profile.connectClass)) {
        _is = true
      }
      return _is
    }
  },
  methods: {
    ...mapActions(dashboardStore, ['setInsurer']),
    ...mapActions(opportunityStore, ['getCounts']),
    ...mapActions(locationStore, ['getNewMemberCount']),
    init() {
      if (!this.isProvider) {
        this.setInsurer(null)
      }
      if (this.isProvider || this.isSuperAdmin) {
        this.getCounts({
          user: this.profile.user,
          type: 'seen'
        })
        this.getNewMemberCount({
          firm: this.profile.firm,
          page: 1,
          offset: 0,
          sortBy: 'asc',
          orderBy: 'firm',
          pageSize: 10,
          lookup: 5,
          status: 'count'
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
